<div class="row">
	<div class="col-lg-12">
		<div class="card" id="blackoutDaysList">
			<div class="card-header border-0">
				<div class="d-flex align-items-center">
					<h5 class="card-title mb-0 flex-grow-1">List Upload</h5>
				</div>
			</div>
			<div class="card-body border border-dashed border-end-0 border-start-0">
				<div *ngIf="!fileSelected" class="margin-top-2 text-center">
					<h2>Upload prospects</h2>
					<input type="file" accept=".csv" (change)="handleFileSelect($event)" style="display: none" #selectFile />
					<button class="btn btn-primary btn-xl" (click)="selectFile.click()"><i class="ri-file-excel-line"></i> Select CSV File</button>
				</div>

				<div class="row" *ngIf="fileSelected">
					<div class="col-6">
						<label for="">Select a campaign</label>
						<app-select-search [values]="campaigns" (onSelected)="setCampaign($event)"></app-select-search>
					</div>

					<div class="col-6">
						<br />
						<input type="file" accept=".csv" (change)="handleFileSelect($event)" style="display: none" #selectFile2 />
						<button class="btn btn-primary" (click)="selectFile2.click()">Change CSV File</button>
						<button class="btn btn-danger" [disabled]="loading" (click)="save_prospects()" style="margin-left: 3px">Save Prospects</button>
					</div>
				</div>

				<div class="row" *ngIf="fileSelected" style="margin-top: 15px;">

					<div class="col-3">
						<div class="form-check form-radio-primary mb-3">
							<input class="form-check-input" type="radio" [(ngModel)]="combineOrReplace" value="COMBINE" id="COMBINE">
							<label class="form-check-label" for="COMBINE">
								Combine Lists
							</label>
						</div>
					</div>
					<div class="col-3">
						<div class="form-check form-radio-primary mb-3">
							<input class="form-check-input" type="radio" [(ngModel)]="combineOrReplace" value="REPLACE" id="REPLACE">
							<label class="form-check-label" for="REPLACE">
								Replace Lists
							</label>
						</div>
					</div>
				</div>
			</div>
			<div *ngIf="loading" align="center">
				<app-loader></app-loader>
				<label for="">Progress</label>
				<ngb-progressbar class="mb-3" [showValue]="true" type="info" [value]="totalProspectsUpload" [max]="arrayPropects.length" ></ngb-progressbar>
			</div>

			<div class="card-body border border-dashed border-end-0 border-start-0" *ngIf="!loading">
				<div *ngIf="fileSelected">
					<div class="row">
						<div class="col-3">
							<label for=""><strong>LMS Prospects Database</strong></label>
						</div>
						<div class="col-3">
							<label for=""><strong>CSV File Headers</strong></label>
						</div>
						<div class="col-3">
							<label for=""><strong>LMS Prospects Database</strong></label>
						</div>
						<div class="col-3">
							<label for=""><strong>CSV File Headers</strong></label>
						</div>
					</div>
					<div class="row">
						<div class="col-3">
							<div *ngFor="let field of ourDB | slice : 0 : 17; let i = index" class="align-middle" style="height: 38px; padding-top: 8px; margin-bottom: 10px">
								<h5>
									<strong>{{ field.name }}:</strong>
								</h5>
							</div>
						</div>
						<div class="col-3">
							<div *ngFor="let field of ourDB | slice : 0 : 17; let i = index" style="height: 38px; margin-bottom: 10px">
								<select [(ngModel)]="prospectDB[field.variable]" [class.is-valid]="prospectDB[field.variable] !== ''" class="form-control">
									<option value="" selected>Select an option</option>
									<option value="{{ key }}" *ngFor="let key of csvKeys" [hidden]="isSelected(key)">
										{{ key }}
									</option>
								</select>
							</div>
						</div>

						<div class="col-3">
							<div *ngFor="let field of ourDB | slice : 17 : 34; let i = index" style="height: 38px; padding-top: 8px; margin-bottom: 10px">
								<h5>
									<strong>{{ field.name }}:</strong>
								</h5>
							</div>
						</div>
						<div class="col-3">
							<div *ngFor="let field of ourDB | slice : 17 : 34; let i = index" style="height: 38px; margin-bottom: 10px">
								<select [(ngModel)]="prospectDB[field.variable]" [class.is-valid]="prospectDB[field.variable] !== ''" class="form-control">
									<option value="" selected>Select an option</option>
									<option value="{{ key }}" *ngFor="let key of csvKeys" [hidden]="isSelected(key)">
										{{ key }}
									</option>
								</select>
							</div>
						</div>
					</div>
					<br />
				</div>
			</div>
		</div>
	</div>
</div>
<script src="https://cdn.jsdelivr.net/npm/choices.js/public/assets/scripts/choices.min.js"></script>
